import cardPainterManager from '../../../../../Widgets/DataPainterWidget/Core/CardPainterManager';
import commandEngine from './CommandEngine';
import { CMD_PNL3_REGISTRY_KEY, META_TYPE, META_VER } from './pnl3CommandRegisteryType';

/**
 * Registers the /pnl3 command with the CommandEngine.
 * Call once at module load from YourLibraryTab (via CommandEngine.bootup).
 *
 * /pnl3 [symbol] — opens a pnl3-summary card. With a symbol (e.g. /pnl3 UNI): opens/
 * refocuses that asset's card (multi-instance, target=symbol). Without a symbol: opens/
 * refocuses one shared "blank" card (target='') that falls back to the last-selected
 * asset for that card, or the first asset if it's never been used — see Pnl3Widget's
 * _onAssetsLoaded.
 */
export function registerPnl3Command() {
    commandEngine.register('/pnl3', {
        hint: '[symbol] — open pnl3 summary, e.g. /pnl3 UNI (symbol optional — opens last-used asset)',
        params: [],
        handler: (params) => {
            const [symbol] = params;
            const target = symbol ? symbol.toUpperCase() : '';

            cardPainterManager.openCard(CMD_PNL3_REGISTRY_KEY, { type: META_TYPE, ver: META_VER, target });
        },
    });
}
